import { SET_PRICE_BREAKERS_DATA } from '../../actions/actionTypes'

export const priceBreakersInitialState = {
  priceBreakersSessionKey: ''
}

export function priceBreakers(state = priceBreakersInitialState, action) {
  switch (action.type) {
    case SET_PRICE_BREAKERS_DATA:
      return Object.assign({}, state, action.payload)
    default:
      return state
  }
}
